// extracted by mini-css-extract-plugin
module.exports = {"root":"Report_root__2dg42","noData":"Report_noData__2XgRl"};